import React from 'react';
import ClaimConfirmation from '../ClaimConfirmation';
import { ProductRecommendations } from '../../components/ProductRecommendations';
import Footer from '../../components/Footer';
import PickupCTA from '../PickupsPage/PickupCTA';
import ReturnInstructions from '../ReturnInstructions';
import Addons from '../Addons';
import s from '../../controllers/Step4/step4Ctrl.module.css';
import ReturnConfirmation from '../ReturnConfirmation';
import { needsReview } from './helpers';
import { Promos } from '../Promos';

export const ConfirmationPage = () => (
  <>
    <Promos area="top" page="confirmation" />
    {needsReview() ? (
      <ClaimConfirmation />
    ) : (
      <div className={s.step_4_inner_container}>
        <return-confirmation>
          <ReturnConfirmation />
        </return-confirmation>
        <Promos area="below-title" page="confirmation" />
        <pickup-cta>
          <PickupCTA />
        </pickup-cta>
        <Promos area="above-instructions" page="confirmation" />
        <div>
          <return-instructions>
            <ReturnInstructions />
          </return-instructions>
        </div>
        <Promos area="below-instructions" page="confirmation" />
      </div>
    )}
    <Addons />
    <product-recommendations>
      <ProductRecommendations />
    </product-recommendations>
    <Promos area="bottom" page="confirmation" />
    <returns-footer>
      <Footer />
    </returns-footer>
  </>
);
